//#region REACT
import axios, { AxiosResponse } from "axios";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { ReactNotifications, Store } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import 'animate.css'
import { useTranslation } from "react-i18next";
//#endregion

//#region UTILS
import { endpoints } from "../../core/constants";
import { LoginProp } from "../../models/internal_api/userInterfaces";
//#endregion

//#region CSS
import "./Login.scss";
//#endregion

//#region IMAGES
import Logo from "../../images/Login/logo.png";
import StockPhoto from "../../images/Login/stockPhoto.jpg";
import loadingGif from "../../images/Global/loading.gif"
//#endregion

async function loginUser(credentials: LoginProp): Promise<AxiosResponse<any, any>> {
  const headers = {
    //'cache': 'default',
    'mode': 'cors',
    'credentials': 'include',
    'content-type': 'application/json'
  }
  console.log("Login url: " + endpoints.login)
  return axios.post(endpoints.login, JSON.stringify(credentials), { headers: headers, withCredentials: true }).then((res: any) => {
    return res?.data;
  }).catch(e => console.log(e));
}

export default function Login({ setToken }: any) {
  //TRANSLATION INIT
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);
  const [username, setUsername] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [passwordShown, setPasswordShown] = useState(false);

  // Handle login form submission
  const handleSubmit = async (e: any) => {
    console.log("Login url: " + endpoints.login)
    e.preventDefault();
    setLoading(true);
    const token = await loginUser({ username, password });

    if (token) {
      setToken(token);
    }
    else {
      setLoading(false);
      Store.addNotification({
        title: t("error"),
        message: t("incorrectUser"),
        type: "danger",
        insert: "bottom",
        container: "bottom-right",
        animationIn: ["animate__animated animate__bounce"],
        animationOut: ["animate__animated animate__fadeOut"],
        dismiss: {
          duration: 3000
        }
      });
    }
  };

  // Password visibility handler
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  return (
    <div className="Login">
      <div className="Login__form-column">
        <div className="Login__logo-container">
          <img src={Logo} alt="Sexto Sentido logo" />
        </div>
        <div className="Login__form-info">
          <h1>{t("login.title")}</h1>
          <p>{t("login.insertLogin")}</p>
        </div>
        <div className="Login__form-container">
          <form onSubmit={handleSubmit}>
            <fieldset>
              <div className="Login__username">
                <label htmlFor="username">{t("login.username")}</label>
                <input
                  id="username"
                  type="text"
                  placeholder={t("login.username")}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
            </fieldset>
            <fieldset>
              <div className="Login__password">
                <label htmlFor="pwd">{t("login.password")}</label>
                <button onClick={(e)=>{e.preventDefault()}}>{t("login.forgotPassword")}</button>
              </div>
              <input
                id="pwd"
                type={passwordShown ? "text" : "password"}
                placeholder={t("login.password")}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i
                id="eye-icon"
                className={passwordShown ? "eye-icon-hide" : "eye-icon-show"}
                onClick={togglePassword}
              ></i>
            </fieldset>
            <div className="Login__submit-button">
              <button className="submit-button" type="submit">
                {loading && <img src={loadingGif} alt="loading..." height="25" />}
                {!loading && <span>{t("login.login")}</span>}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="Login__img-column">
        <img
          src={StockPhoto}
          alt="Elderly woman looking at her smartphone"
          className="Login__img-stock"
        ></img>
      </div>
      <ReactNotifications />
    </div>
  );
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired,
};
